'use client';

import { Centrifuge } from 'centrifuge';

let client: Centrifuge | null | undefined;

// The tab's one Centrifugo connection (anonymous), opened on first use, never during SSR; every channel subscribes on
// it. null without a URL configured: the board then refetches its seed on a timer, as it does while the socket is down.
export function getCentrifugo(): Centrifuge | null {
  if (client === undefined) {
    const url = process.env.NEXT_PUBLIC_CENTRIFUGO_URL;
    client = url ? new Centrifuge(url) : null;
    client?.connect();
  }
  return client;
}
